import { useState } from "react";
import { Modal, Form, Input, Button, Alert, message } from "antd";
import { useAuth } from "../../../context/AuthContext";
import { useClient } from "../../../context/ClientContext";

// Qué pasó con el alta, según lo que respondió el server. En local se agrega
// el detalle del ERP para poder verificarlo; al cliente no le sirve esa jerga.
const AVISOS = {
  creado:    { tipo: "success", texto: "Listo, te dimos de alta como cliente.", tecnico: "ERP: cliente creado" },
  existente: { tipo: "success", texto: "Ya eras cliente: usamos los datos que tenemos.", tecnico: "ERP: cliente existente" },
  pendiente: { tipo: "info",    texto: "Guardamos tus datos.", tecnico: "ERP sin respuesta: queda pendiente, se sincroniza con el primer pedido" },
  sin_erp:   { tipo: "success", texto: "Listo, guardamos tus datos.", tecnico: "tienda sin ERP: cliente local" },
};

function avisarAlta(estado) {
  const aviso = AVISOS[estado];
  if (!aviso) return;
  const texto = process.env.NODE_ENV === "development"
    ? `${aviso.texto} (${aviso.tecnico})`
    : aviso.texto;
  message[aviso.tipo](texto, 5);
}

export function RegistrarClienteModal({ open, onClose, onSuccess }) {
  const { registrarCliente, user } = useAuth();
  const { theme } = useClient();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    const values = form.getFieldsValue();
    if (!values.nombre?.trim()) {
      setError("El nombre es obligatorio.");
      return;
    }
    // Con uno de los dos, si ya sos cliente te reconocemos en vez de darte de
    // alta de nuevo.
    if (!values.dni?.trim() && !values.cuit?.trim()) {
      setError("Necesitamos tu DNI o CUIT.");
      return;
    }
    setLoading(true);
    const result = await registrarCliente(values);
    setLoading(false);
    if (result.success) {
      avisarAlta(result.erp);
      form.resetFields();
      setError("");
      onSuccess();
    } else {
      setError(result.message || "Ocurrió un error. Intentá de nuevo.");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={loading ? undefined : onClose}
      title={<span style={{ fontWeight: 600 }}>Completá tus datos</span>}
      footer={[
        <Button key="cancel" onClick={onClose} disabled={loading}>Cancelar</Button>,
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={handleSubmit}
          style={{ backgroundColor: theme.primaryColor, borderColor: theme.primaryColor, color: theme.primaryTextColor }}
        >
          Continuar
        </Button>,
      ]}
      width={420}
      styles={{ body: { paddingTop: 8 } }}
    >
      <p style={{ color: "#888", marginBottom: 16, fontSize: 14 }}>
        Para finalizar el pedido necesitamos algunos datos. Solo te los pedimos una vez.
      </p>
      {error && <Alert type="error" message={error} style={{ marginBottom: 12 }} />}
      {/* Precargado con lo que ya sabemos del usuario, para no pedirlo dos veces. */}
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          nombre: [user?.nombre, user?.apellido].filter(Boolean).join(" "),
          telefono: user?.telefono || "",
        }}
      >
        <Form.Item label="Nombre o razón social *" name="nombre" rules={[{ required: true, message: 'El nombre es obligatorio' }]}>
          <Input autoFocus />
        </Form.Item>
        <Form.Item label="DNI" name="dni" extra="Si tenés CUIT, con eso alcanza.">
          <Input inputMode="numeric" placeholder="12345678" />
        </Form.Item>
        <Form.Item label="CUIT" name="cuit">
          <Input placeholder="20-12345678-9" />
        </Form.Item>
        <Form.Item label="Teléfono" name="telefono">
          <Input />
        </Form.Item>
        <Form.Item label="Domicilio" name="domicilio">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
}
